import { Injectable } from '@angular/core';
import { HttpError } from '../../domain/http/http-error.model';

@Injectable()
export class HttpErrorService {

  private error: HttpError;

  setError(error: HttpError) {
      this.error = error;
  }

  removeError(): HttpError {
      let error = this.error;
      this.error = null;
      return error;
  }
}
